$(window).on('ready load', function () {
  $('[data-action="toggle-nav"]').click(function (e) {
    e.preventDefault();
    $('.nav__wrapper, [data-action="toggle-nav"], body').toggleClass('is-open');
  });

  $('.nav__caret').click(function () {
    $(this).toggleClass('is-open');
    $(this).next('.nav__dropdown').toggleClass('is-open').slideToggle(200);
    $(this).closest('li').toggleClass('is-open');
  });

  $(window).on('resize', function () {
    $('.nav__wrapper, .nav__backdrop, [data-action="toggle-nav"], body, .s7filter, .nav__dropdown, .nav__caret').removeClass('is-open');
    $('.nav__dropdown').hide();
  });

  // filter popup javascript - Not used yet
  // $(document).on('click', '[data-action="toggle-filter"]', function (e) {
  //   e.preventDefault();
  //   $('.s7filter, .nav__backdrop--filter, body').toggleClass('is-open');
  // });
});



// WEBPACK FOOTER //
// ./scripts/global/nav.js